export function registerCheckout() {
  jQuery(document).on("submit", "#customRegisterFormLogin", function (e) {
    e.preventDefault();

    var form = jQuery(this),
      email = form.find("#registerEmail").val(),
      password = form.find("#registerPassword").val(),
      remember = form.find("#rememberMe").is(":checked") ? 1 : 0;

    form.find(".login-error").remove();

    jQuery.ajax({
      url: my_ajax_object.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: "my_ajax_login_user",
        email: email,
        password: password,
        remember: remember,
      },
      success: function (res) {
        if (!res.success) {
          // exibe erro abaixo do password
          form
            .find("#registerPassword")
            .closest(".wrapper-input-password")
            .after(
              '<div class="login-error text-danger">' +
                res.data.message +
                "</div>"
            );
          return;
        } else {
          jQuery(".single-step.step-1").html(res.data.personal_html);
          jQuery(".single-step.step-2").html(res.data.step2_html);

          // jQuery("#customCartContainer").html(res.data.cart_items_html);
          // jQuery(".footer-sacola").html(res.data.cart_footer_html);
          // console.log("Carrinho Box: ", res.data.cart_items_html);
        }
      },
      error: function (err) {
        console.log("Ajax login error", err);
        form
          .find("#registerPassword")
          .closest(".wrapper-input-password")
          .after(
            '<div class="login-error text-danger"><?php echo esc_js(__( "Erro de conexão ao efetuar login.", "seu-text-domain" )); ?></div>'
          );
      },
    });
  });

  jQuery(document).on("submit", "#customRegisterForm", function (e) {
    e.preventDefault();

    var name = jQuery("#registerName").val();
    var email = jQuery("#registerEmail").val();
    var password = jQuery("#registerPassword").val();
    var remember = jQuery("#rememberMe").is(":checked") ? 1 : 0;

    jQuery.ajax({
      url: my_ajax_object.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: "my_ajax_register_user",
        name: name,
        email: email,
        password: password,
        remember: remember,
      },
      success: function (response) {
        // Se der erro, exibe e PARA AQUI
        if (!response.success) {
          console.log(response.data.message);
          return; // <<< interrompe a função
        }

        console.log(response.data.message);
        jQuery(".signupBoxMain").hide();

        jQuery.ajax({
          url: my_ajax_object.ajax_url,
          method: "POST",
          dataType: "json",
          data: { action: "my_load_confirmation_register_partial" },
          success: function (resp2) {
            if (resp2.success) {
              jQuery("#authContainer").html(resp2.data.html);
            } else {
              console.log(
                "Erro ao carregar confirmação: " + resp2.data.message
              );
            }
          },
          error: function (err2) {
            console.log("Erro ao carregar confirmação:", err2);
          },
        });
      },
      error: function (err) {
        console.log("Erro na requisição AJAX:", err);
        console.log("Erro de conexão ao salvar seus dados.");
      },
    });
  });

  jQuery(document).on("submit", "#registerAddressForm", function (e) {
    e.preventDefault();
    const form = jQuery(this);

    // coleta os dados
    const data = {
      action: "save_user_address",
      shipping_address_1: form.find('[name="shipping_address_1"]').val(),
      shipping_address_2: form.find('[name="shipping_address_2"]').val(),
      shipping_state: form.find('[name="shipping_state"]').val(),
      shipping_district: form.find('[name="shipping_district"]').val(),
      shipping_postcode: form.find('[name="shipping_postcode"]').val(),
      shipping_city: form.find('[name="shipping_city"]').val(),
      delivery_instructions: form.find('[name="delivery_instructions"]').val(),
      save_address: form.find('[name="save_address"]').is(":checked") ? 1 : 0,
    };

    jQuery.post(
      my_ajax_object.ajax_url,
      data,
      function (resp) {
        if (resp.success) {
          // avança para o step 3
          $(".person-name").text(resp.data.full_name);
          $(".person-phone").text(resp.data.phone);

          let line1 = resp.data.address_1;
          if (resp.data.address_2) line1 += ", " + resp.data.address_2;
          if (resp.data.district) line1 += ", " + resp.data.district;
          if (resp.data.city) line1 += " – " + resp.data.city;
          $(".address-line1").text(line1);

          $(".address-line2").text(resp.data.eircode + ", Irlanda");

          if (resp.data.instructions) {
            // Se já existir um parágrafo, atualiza; senão, adiciona
            const instr =
              '<p class="delivery-instructions">Instruções de entrega: ' +
              resp.data.instructions +
              "</p>";
            if ($(".delivery-instructions").length) {
              $(".delivery-instructions").text(resp.data.instructions);
            } else {
              $(".white-card-address .d-flex.align-items-center").append(instr);
            }
          }

          // 2) Finalmente, avança para o Step 3
          jQuery(".content-page-checkout .single-step.step-2").removeClass(
            "active"
          );
          jQuery(".content-page-checkout .single-step.step-3").addClass(
            "active"
          );
          jQuery(".content-page-checkout .single-step.step-2").removeClass(
            "active"
          );
          jQuery(".content-page-checkout .single-step.step-3").addClass(
            "active"
          );
        } else {
          console.log(resp.data.message);
          jQuery("#errorMsg span").text(resp.data.message);
          jQuery("#errorMsg").show();
        }
      },
      "json"
    );
  });

  jQuery(document).on("input", "#registerAddressForm input", function () {
    jQuery("#errorMsg").hide();
  });

  jQuery(document).on("click", "#editButton", function (e) {
    e.preventDefault();
    jQuery("#confirmationForm input").prop("disabled", false);
  });

  jQuery(document).on("submit", "#confirmationForm", function (e) {
    e.preventDefault();

    var name = jQuery("#confirmName").val();
    var email = jQuery("#confirmEmail").val();
    var phone = jQuery("#confirmPhone").val();

    jQuery.ajax({
      url: my_ajax_object.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: "my_ajax_update_user_data",
        name: name,
        email: email,
        phone: phone,
      },
      success: function (resp) {
        if (resp.success) {
          alert("Dados atualizados com sucesso!");
          jQuery("#confirmationForm input").prop("disabled", true);
        } else {
          alert("Erro: " + resp.data.message);
        }
      },
      error: function (err) {
        console.log("Erro na requisição AJAX:", err);
      },
    });
  });
}
